import { State, Action, Selector, StateContext } from '@ngxs/store';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { ShipmentTransportOrderCommentsService } from './shipment-transport-order-comments.service';
import { Injectable } from '@angular/core';
import { NotificationService } from '../../../../../common/services';
import { Error, CustomHttpErrorResponse } from '../../../../../common/constants/error';
import { ShipmentCommentsModel } from '../../../../models';
import {
  ShipmentTransportOrderCommentsInitialState,
  ShipmentTransportOrderCommentsLoad,
  ShipmentTransportOrderCommentsSave,
} from './shipment-transport-order-comments.actions';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export interface ShipmentTransportOrderCommentsStateModel {
  comments: ShipmentCommentsModel[];
  loaded: boolean;
}

const initialState: ShipmentTransportOrderCommentsStateModel = {
  comments: null,
  loaded: false,
};

@State<ShipmentTransportOrderCommentsStateModel>({
  name: 'shipmentTransportOrderComments',
  defaults: initialState,
})
@Injectable()
export class ShipmentTransportOrderCommentsState {
  constructor(
    private shipmentTransportOrderCommentsService: ShipmentTransportOrderCommentsService,
    private notificationService: NotificationService,
  ) {}
  @Selector()
  static getComments(state: ShipmentTransportOrderCommentsStateModel): ShipmentCommentsModel[] {
    return state.comments;
  }

  @Selector()
  static getLoaded(state: ShipmentTransportOrderCommentsStateModel): boolean {
    return state.loaded;
  }

  @Action(ShipmentTransportOrderCommentsLoad)
  getTransportOrderComments(
    ctx: StateContext<ShipmentTransportOrderCommentsStateModel>,
    { payload }: ShipmentTransportOrderCommentsLoad,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.shipmentTransportOrderCommentsService.getShipmentTransportOrderComments(payload).pipe(
      map((comments: ShipmentCommentsModel[]) => {
        ctx.patchState({ comments, loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(ShipmentTransportOrderCommentsSave)
  saveTransportOrderComment(
    ctx: StateContext<ShipmentTransportOrderCommentsStateModel>,
    { payload }: ShipmentTransportOrderCommentsSave,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.shipmentTransportOrderCommentsService
      .saveShipmentTransportOrderComment(payload.transportOrder, payload.comment)
      .pipe(
        map((comment: ShipmentCommentsModel) => {
          ctx.patchState({ comments: [...ctx.getState().comments, comment], loaded: true });
        }),
        catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
      );
  }

  @Action(ShipmentTransportOrderCommentsInitialState)
  setInitialState(ctx: StateContext<ShipmentTransportOrderCommentsStateModel>): void {
    ctx.setState(initialState);
  }
}
